"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Query = void 0;
class Query {
    constructor(query) {
        this.limit = 20;
        this.offset = 0;
        this.where = {};
        Object.assign(this, query || {});
    }
    type(name) {
        this.where['type'] = name;
        return this;
    }
    setAttributes(attrs) {
        this.attributes = attrs;
        return this;
    }
    setOrder(key, direction = 'ASC') {
        this.order = [key, direction];
        return this;
    }
}
exports.Query = Query;
//# sourceMappingURL=query.js.map